import { render } from "./DistributorLayout.vue?vue&type=template&id=6945001c&scoped=true"
import script from "./DistributorLayout.vue?vue&type=script&lang=js"
export * from "./DistributorLayout.vue?vue&type=script&lang=js"

import "./DistributorLayout.vue?vue&type=style&index=0&id=6945001c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6945001c"]])

export default __exports__